const NS = 'ScheduleCtrl';

export default function ScheduleCtrl(
  $log, $state, scheduleService
) {
  "ngInject";

  const vm = this;
  vm.edit = edit;

  getSchedules();

  function getSchedules() {
    scheduleService.getDaySchedules().then(function (schedules) {
      vm.schedules = schedules;
    }).catch(function (err) {
      $log.error(err);
    });
  }

  function edit(evt, schedule) {
    $state.go('settings.schedule.edit', {
      id: encodeURIComponent(schedule._id)
    });
  }
}
